export const STATUS = {
    Registered: 'Registered',
    CertViolation: 'CertViolation',
    Passed: 'Passed',
    PassedQuestions: 'PassedQuestions',
    Failed: 'Failed',
    Cancelled: 'Cancelled',
    Rejected: 'Rejected',
};
